import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SyncTile from '../../Order/SyncTile';

export const SyncPage = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.background}>
            <div className={classes.spacer80}>
                {t("Synchronisation")}
            </div>
            <Grid container spacing={2} className={classes.gridContainer}>
                <Grid className={classes.gridmargin}>
                    <SyncTile></SyncTile>
                </Grid>
            </Grid>
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingLeft: "20px"
    },
    gridmargin: {

    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
        maxWidth: "1600px",
        marginRight: "auto",
        marginLeft: "auto"
    },
    background: {
        width: '100%',
        position: "relative",
        top: "60px",
    }
});